module.exports = __webpack_public_path__ + "static/media/sun.7fd7c691.svg";